import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, authClient, json } from "../../../api";

export function useGeneralSettings(workspaceId: string) {
  const client = useQueryClient();
  const organizations = authClient.useListOrganizations();
  const query = useQuery({
    queryKey: ["workspace-general", workspaceId],
    queryFn: () =>
      api<{ name: string; role: string }>(`/workspaces/${workspaceId}/general`),
  });
  const rename = useMutation({
    mutationFn: (name: string) =>
      api(`/workspaces/${workspaceId}/general`, {
        ...json({ name }),
        method: "PATCH",
      }),
    onSuccess: async () => {
      await client.invalidateQueries();
      await organizations.refetch();
    },
  });
  const remove = useMutation({
    mutationFn: (confirmation: string) =>
      api(`/workspaces/${workspaceId}`, {
        ...json({ confirmation }),
        method: "DELETE",
      }),
  });
  return { query, rename, remove };
}
